// JS for block-specific behavior only
console.log('res hero block loaded');